import type { ComponentProps } from 'react'

import { AtendimentoTriggerChile } from '@/features/atendimento/chile/components/atendimento-trigger-chile'
import { PageContainer, PageContent, PageHeader, PageLayout, PageSubtitle, PageTitle } from '@/layouts/page'

export const PageLayoutChile = (props: ComponentProps<typeof PageLayout>) => (
  <PageLayout atendimentoTrigger={<AtendimentoTriggerChile />} {...props} />
)

export const PageChile = Object.assign(PageLayoutChile, {
  Main: PageContainer,
  Header: PageHeader,
  Title: PageTitle,
  Description: PageSubtitle,
  Section: PageContent,
})
